import toNumber from 'lodash/toNumber';
import { NUMBER_SIZE_LIMIT_WHEN_ENABLED } from './constants.tsx';

/**
 * Check if the value is a valid string number for JQL. It also empty strings.
 */
export const isNumberJQLValid = (value: string): boolean =>
	/^-?(\d+(\.\d*)?|\.\d+)$|^$/.test(`${value}`);

export const isUnsubmittedValueNotANumber = (unsubmittedValue: string): boolean =>
	!isNumberJQLValid(unsubmittedValue);

export const isUnsubmittedNumberTooLarge = (unsubmittedValue: number): boolean =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	(toNumber(unsubmittedValue) as number) > NUMBER_SIZE_LIMIT_WHEN_ENABLED;
